export default __webpack_public_path__ + "static/media/telcom-logo.c828d489.c828d489.png";